<script>
import { ref } from 'vue';
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'

import { required, maxLength, minValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  setup: () => ({
    v$: useVuelidate()
  }),

  components: {
    GenericCustomAutocompleteV2,
    Dialog,
    ResponsiveButton,
},
  data() {
    return {
      vesselProtocols: [],
      dateFrom: null,
      dateTo: null,
      searchData: {},
      searchDialogVisible: false,
      searchSubmitted: false,
    }
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    },
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    },
  },
  created() {
    //this.config = config.getConfiguration('VesselProtocolSearch');
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'vesselProtocolSearch.page_title');
    this.loadFromCache();
  },
  watch: {
    searchDialogVisible(newValue){
      if (!newValue) {
          this.searchSubmitted = false;
      }
    },
  },
  methods: {
    submitSearch(){
      this.searchSubmitted = true;

      this.searchData.dateFrom = this.dateFrom && Utils.formatDateForAPI(this.dateFrom);
      this.searchData.dateTo = this.dateTo && Utils.formatDateForAPI(this.dateTo);
      this.$store.dispatch("generic/setLoading", true);
      this.saveCache();
      Service.searchVesselProtocolToMongoDB(this.searchData, ({success, data}) => {
          this.$store.dispatch("generic/setLoading", false);
          this.searchDialogVisible = false;
          if(success){
              this.vesselProtocols = data;
          }
      })
    },
    resetSearch() {
      this.searchData = {};
      this.dateFrom = null;
      this.dateTo = null;
      this.searchSubmitted = false;
    },
    openVesselProtocol(data) {
      let uri = `/vessel-protocol?id=${data.data.vesselProtocolLots[0].idMovementInstructionLot}`;
      this.$router.push(uri);
    },
    loadFromCache(){
      let cacheData = this.$store.getters['cacheDataStore/getGridCache']('vesselProtocolSearch');
      if(cacheData){
        this.dateFrom = cacheData.dateFrom;
        this.dateTo = cacheData.dateTo;
        this.searchData = cacheData.searchData;
        this.submitSearch();
      }
    },
    saveCache(){
      let cacheData = {
        name: 'vesselProtocolSearch',
        filters: {
          dateFrom: this.dateFrom,
          dateTo:this.dateTo,
          searchData: this.searchData
        },
      };
      this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
    },
    protocolStatusTooltip(data){
      let statusTooltip = "";
      if(!data.isClosed && data.protocolNumber){
        return this.$t('vesselProtocolSearch.statusOpened');
      }
      if(data.isClosed){
        return this.$t('vesselProtocolSearch.statusClosed');
      }
      if(!data.isClosed && !data.protocolNumber){
        return this.$t('vesselProtocolSearch.statusNoProtocol');
      }
    },
    exportExcel(){
      let fileName =  `Protocols`;
      this.$store.dispatch("generic/setLoading", true);
      Service.protocolSearchExportExcel(this.vesselProtocols, response => {
          this.$store.dispatch("generic/setLoading", false);
          if(response.success){
              this.downloadDocument(response.data, fileName)
          }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
      });
    },
    downloadDocument(id, name){
      let body = {
          id: id
      };

      Service.printProtocolSearchExcel(body, ({success, data, message}) => {
          
          if(success){
              var fileURL = window.URL.createObjectURL(new Blob([data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', name + '.xlsx');
              document.body.appendChild(fileLink);
          
              fileLink.click();
          } else{
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    }
  }
}

</script>

<template>
  <main>
    <Dialog :header="$t('btn.search')" v-model:visible="searchDialogVisible" :style="{ width: '90vw' }" :modal="true">
      <div class="grid">
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.dateFrom') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="dateFrom"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.dateTo') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="dateTo"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.protocolNumber') }}</label>
              <InputText
                  class="p-inputtext-sm w-full"
                  v-model="searchData.protocolNumber" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.protocolDateFrom') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="searchData.protocolDateFrom"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.protocolDateTo') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="searchData.protocolDateTo"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.voyageNumber') }}</label>
              <InputText 
                  class="p-inputtext-sm w-full"
                  v-model="searchData.voyageNumber" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.externalVoyageNumber') }}</label>
              <InputText 
                  class="p-inputtext-sm w-full"
                  v-model="searchData.externalVoyageNumber" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('plant') }}</label>
              <GenericCustomAutocompleteV2 
                  class="p-inputtext-sm w-full"
                  v-model="searchData.plant"
                  :format="{ label: 'label', value: 'label' }"
                  api="masterdata/registry-plant-combo" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.incoterms') }}</label>
              <InputText 
                  class="p-inputtext-sm w-full"
                  v-model="searchData.incoterms" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('operationType.fk') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.operationType"
                :format="{ label: 'label', value: 'label' }"
                api="masterdata/operation-type-combo" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vessel.fk') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.vessel" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('productDescription') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.productDescription"
                :format="{ label: 'label', value: 'label' }"
                api="masterdata/product-combo" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.fiscalCommunicationNumber') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.fiscalCommunicationNumber" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.originCountry') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.originCountry"
                :format="{ label: 'label', value: 'extraData' }"
                api="masterdata/country-and-territory-combo-list" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.destinationCountry') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.destinationCountry"
                :format="{ label: 'label', value: 'extraData' }"
                api="masterdata/country-and-territory-combo-list" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.combinedNomenclature') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.combinedNomenclature" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.customer') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.customer" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.inspectionCompany') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.inspectionCompany"
                :format="{ label: 'label', value: 'label' }"
                api="masterdata/company-combo" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.cargoDestination') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.cargoDestination" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.CEEDestinations') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.CEEDestinations" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.extraCEEDestinations') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.extraCEEDestinations" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.importerExporter') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.importerExporter"
                :format="{ label: 'label', value: 'label' }"
                api="masterdata/company-combo"
                :queryField="{isOwner: true}" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('fiscalDestination.fk') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="searchData.fiscalDestination"
                :format="{ label: 'description', value: 'shortDescription' }"
                api="masterdata/fiscal-destination"
                :queryField="{isOwner: true}" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.direction') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData.direction" />
          </div>         
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.tanks') }}</label>
            <InputText 
              class="p-inputtext-sm w-full"
              v-model="searchData['assets.tanks']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.pipes') }}</label>
            <InputText 
              class="p-inputtext-sm w-full"
              v-model="searchData['assets.pipes']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.pumps') }}</label>
            <InputText 
              class="p-inputtext-sm w-full"
              v-model="searchData['assets.pumps']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.aspirations') }}</label>
            <InputText 
              class="p-inputtext-sm w-full"
              v-model="searchData['assets.aspirations']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.measures') }}</label>
            <InputText 
              class="p-inputtext-sm w-full"
              v-model="searchData['assets.measures']" />
          </div>  
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.platform') }}</label>
            <InputText 
              class="p-inputtext-sm w-full"
              v-model="searchData['assets.platform']" />
          </div>        
      </div>

      <div header="Custom Informations" class="grid">
        <div class="col-12" /> <!--Sezione INFO DOGANALI-->
        <div class="col-12"><h5>{{ $t("vesselProtocolSearch.customInformation") }}</h5></div>
        <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.mrn') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.mRN']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.noticeECustomBillCode') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.noticeECustomBillCode']" />
          </div>          
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.finalECustomBillCode') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.finalECustomBillCode']" />
          </div>          
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.registerType') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.registerType']" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.registerDate') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="searchData['vesselProtocolCustomInformations.registerDate']"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.eRegistrationCode') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.eRegistrationCode']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.field22') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.field22']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.field33') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.field33']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.statisticValue') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.statisticValue']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.totalTaxAmount') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.totalTaxAmount']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.a93Number') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.a93Number']" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.periodicPaymentExpiration') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="searchData['vesselProtocolCustomInformations.periodicPaymentExpiration']"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.customScheme') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.customScheme']" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.a2Number') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.a2Number']" />
          </div>
          <div class="col-3 field">
              <label>{{ $t('vesselProtocolSearch.a2Date') }}</label>
              <Calendar
                  class="p-inputtext-sm w-full"
                  placeholder="DD/MM/AAAA"
                  v-model="searchData['vesselProtocolCustomInformations.a2Date']"
                  dateFormat="dd/mm/yy" :showTime="false"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          <div class="col-3 field">
            <label>{{ $t('vesselProtocolSearch.releaseCode') }}</label>
            <InputText 
                class="p-inputtext-sm w-full"
                v-model="searchData['vesselProtocolCustomInformations.releaseCode']" />
          </div>
      </div>

      <template #footer>
          <ResponsiveButton :label="$t('btn.reset')"
              :disabled="!uiPermissions('').isEnabled"
              icon="pi pi-sync" class="p-button-sm p-button-outlined m-1"
              @click="resetSearch" />
          <ResponsiveButton :label="$t('btn.search')"
              icon="pi pi-search" class="p-button-sm m-1"
              @click="submitSearch" />
      </template>
  </Dialog>
  <Toolbar>
    <template #start>
      <div class="grid formgrid">
        <div class="col-12 lg:col-2 field">
          <label>{{ $t('vesselProtocolSearch.dateFrom') }}</label>
          <Calendar
            class="p-inputtext-sm w-full"
            placeholder="DD/MM/AAAA"
            v-model="dateFrom"
            dateFormat="dd/mm/yy" :showTime="false"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-2 field">
          <label>{{ $t('vesselProtocolSearch.dateTo') }}</label>
          <Calendar
            class="p-inputtext-sm w-full"
            placeholder="DD/MM/AAAA"
            v-model="dateTo"
            dateFormat="dd/mm/yy" :showTime="false"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-2 field">
            <label>{{ $t('vesselProtocolSearch.protocolDateFrom') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="searchData.protocolDateFrom"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-2 field">
            <label>{{ $t('vesselProtocolSearch.protocolDateTo') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="searchData.protocolDateTo"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-4 field">
          <Button :label="$t('btn.search')" icon="pi pi-search" class="p-button-outlined p-button-sm my-5" @click="submitSearch" />
          <Button icon="pi pi-cog" class="p-button-outlined p-button-sm my-5 mx-3" @click="searchDialogVisible = true" />
          <Button :label="$t('btn.export')" icon="pi pi-file-excel" class="p-button-outlined p-button-sm my-5" @click="exportExcel" :disabled = "!(this.vesselProtocols.length > 0)"  />
        </div>
      </div>
    </template>
  </Toolbar>
    <DataTable :value="vesselProtocols" showGridlines stripedRows class="scrollable">
      <Column style="width:8rem">
        <template #body="slotProps">
            <ResponsiveButton :icon="slotProps.data.vesselProtocolLots != null && slotProps.data.vesselProtocolLots.length > 1 ? 'fa-regular fa-folder-open' : 'pi pi-info'" class="grid-action-btn p-button-rounded p-button-outlined" @click="openVesselProtocol(slotProps)" />
        </template>
      </Column>
      <Column field="status" :header="$t('vesselProtocolSearch.status')">
        <template #body="slotProps">
          <i style="font-size: 2rem"
          v-tooltip="protocolStatusTooltip(slotProps.data)"
          :class="{
            'pi pi-circle-fill': true,
            'no-protocol-number': !slotProps.data.isClosed && !slotProps.data.protocolNumber,
            'closed-protocol' : slotProps.data.isClosed,
            'opened-protocol': !slotProps.data.isClosed && slotProps.data.protocolNumber
          }"></i>
        </template>
      </Column>
      <Column field="protocolNumber" :header="$t('vesselProtocolSearch.protocolNumber')"></Column>
      <Column field="protocolDate" :header="$t('vesselProtocolSearch.protocolDate')">
        <template #body="slotProps">
          {{ slotProps.data.protocolDate ? utils.formatDate(utils.dateToCurrentTimeZone(slotProps.data.protocolDate)): null}}
        </template>
      </Column>
      <Column field="voyageNumber" :header="$t('vesselProtocolSearch.voyageNumber')"></Column>
      <Column field="externalVoyageNumber" :header="$t('vesselProtocolSearch.externalVoyageNumber')"></Column>
      <Column field="plant" :header="$t('plant')"></Column>
      <Column field="incoterms" :header="$t('vesselProtocolSearch.incoterms')"></Column>
      <Column field="operationType" :header="$t('operationType.fk')"></Column>
      <Column field="vessel" :header="$t('vessel.fk')"></Column>
      <Column field="productDescription" :header="$t('product.fk')"></Column>
      <Column field="fiscalCommunicationNumber" :header="$t('vesselProtocolSearch.fiscalCommunicationNumber')"></Column>
      <Column field="originCountry" :header="$t('vesselProtocolSearch.originCountry')"></Column>
      <Column field="destinationCountry" :header="$t('vesselProtocolSearch.destinationCountry')"></Column>
      <Column field="combinedNomenclature" :header="$t('vesselProtocolSearch.combinedNomenclature')"></Column>
      <Column field="customer" :header="$t('vesselProtocolSearch.customer')"></Column>
      <Column field="inspectionCompany" :header="$t('vesselProtocolSearch.inspectionCompany')"></Column>
      <Column field="cargoDestination" :header="$t('vesselProtocolSearch.cargoDestination')"></Column>
      <Column field="CEEDestinations" :header="$t('vesselProtocolSearch.CEEDestinations')"></Column>
      <Column field="extraCEEDestinations" :header="$t('vesselProtocolSearch.extraCEEDestinations')"></Column>
      <Column field="importerExporter" :header="$t('vesselProtocolSearch.importerExporter')"></Column>
      <Column field="fiscalDestination" :header="$t('fiscalDestination.fk')"></Column>
      <Column field="direction" :header="$t('vesselProtocolSearch.direction')"></Column>
      <Column field="assets.tanks" :header="$t('vesselProtocolSearch.tanks')"></Column>
      <Column field="assets.pipes" :header="$t('vesselProtocolSearch.pipes')"></Column>
      <Column field="assets.pumps" :header="$t('vesselProtocolSearch.pumps')"></Column>
      <Column field="assets.aspirations" :header="$t('vesselProtocolSearch.aspirations')"></Column>
      <Column field="assets.measures" :header="$t('vesselProtocolSearch.measures')"></Column>
      <Column field="assets.platform" :header="$t('vesselProtocolSearch.platform')"></Column>
    </DataTable>
  </main>
</template>

<style>

    .scrollable {
        overflow-x: auto;
    }

    .closed-protocol{
      color: #cf000f !important;
    }

    .opened-protocol{
      color: #90c695 !important;
    }

    .no-protocol-number{
      color: #d8fa08 !important;
    }
</style>
